'use client';

import { FacetAccordion } from '../../FacetAccordion';
import { FacetDropdown } from '../../FacetDropdown';
import { FlatFacetShellProps } from './FlatFacetShell.types';

/**
 * Shared chrome for the SSR flat facets: the horizontal variant renders a
 * FacetDropdown pill, every other variant a FacetAccordion — wiring that was
 * previously copy-pasted across the five facet components.
 */
export const FlatFacetShell = ({
  title,
  clearLabel,
  selectedCount,
  onClear,
  variant,
  className,
  isOpen,
  onToggle,
  disabled = false,
  children,
}: FlatFacetShellProps) => {
  if (variant === 'horizontal') {
    return (
      <FacetDropdown
        label={title}
        selectedCount={selectedCount}
        clearLabel={clearLabel}
        onClear={onClear}
        className={className}
        disabled={disabled}
      >
        {children}
      </FacetDropdown>
    );
  }

  return (
    <FacetAccordion
      title={title}
      variant={variant}
      className={className}
      onClear={onClear}
      clearLabel={clearLabel}
      showClear={variant === 'drawer' && selectedCount > 0}
      disabled={disabled}
      defaultOpen={variant !== 'drawer'}
      selectedCount={selectedCount}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      {children}
    </FacetAccordion>
  );
};
